import { useState } from 'react';
import { useRecoilState, useRecoilStateLoadable } from 'recoil';
import { useTranslation } from 'react-i18next';
import {
  currentUserDetailsAtom,
  paymentTermsDialogDismissedAtom,
} from '../../store/user';
import { getUser, submitPaymentTermsDecision } from '../../utils/api';
import { setPaymentTermsDialogDismissed } from '../../utils/auth';
import useSnackbar from '../../utils/useSnackbar';
import { RECOIL_LOADABLE_DONE_STATE } from '../../constants/constants';

export default function usePaymentTermsDecision() {
  const [t] = useTranslation();
  const { showSuccess, showError } = useSnackbar();
  const [userLoadable, setCurrentUserDetails] = useRecoilStateLoadable(
    currentUserDetailsAtom,
  );
  const [isDismissed, setIsDismissed] = useRecoilState(
    paymentTermsDialogDismissedAtom,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isRequired =
    userLoadable.state === RECOIL_LOADABLE_DONE_STATE &&
    userLoadable.contents?.paymentTermsUpdateRequired === true;

  const handleDecision = (accepted) => {
    setIsSubmitting(true);
    submitPaymentTermsDecision(accepted)
      .then(() => getUser())
      .then((response) => {
        setCurrentUserDetails(response.data);
        setPaymentTermsDialogDismissed();
        setIsDismissed(true);
        showSuccess(
          t(
            accepted
              ? 'paymentTermsDialog.acceptedSuccess'
              : 'paymentTermsDialog.rejectedSuccess',
          ),
        );
      })
      .catch(() => {
        showError(t('paymentTermsDialog.error'));
      })
      .finally(() => setIsSubmitting(false));
  };

  return { isModalOpen: isRequired && !isDismissed, isSubmitting, handleDecision };
}
